import React from 'react';

import './Antrag.css';

interface PersonalDataFormProps {
    formData: {
        firstName: string | null;
        lastName: string | null;
        email: string | null;
        gender: string | null;
        phone: string | null;
        citizenship: string | null;
        birthDate: string | null;
        birthPlace: string | null;
        street: string | null;
        zip: string | null;
        city: string | null;
        country: string | null;
        familyStatus: string | null;
        formerName: string | null;
    };
    handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
    countries: string[];
    isViewOnly: boolean;
    showValidation: boolean;
}

const PersonalDataForm: React.FC<PersonalDataFormProps> = ({ formData, handleChange, countries, isViewOnly, showValidation }) => {

    const formatDateForInput = (dateString: string | null): string => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toISOString().split('T')[0];
    };

    return (
        <div>
            <div className='personal-antrag-data'>
                <div className='form-columns'>
                    <div className="form-group-antrag">
                        <label className='form-label' htmlFor='PersonalDataFirstName'>Vorname</label>
                        <input
                            id='PersonalDataFirstName'
                            autoComplete={'given-name'}
                            tabIndex={isViewOnly ? -1 : 0}
                            className={`form-control${showValidation && !formData.firstName ? ' error' : ''}`}
                            title=''
                            name='firstName'
                            type="text"
                            maxLength={40}
                            value={formData.firstName ?? ''}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group-antrag">
                        <label className='form-label' htmlFor='PersonalDataLastName'>Nachname</label>
                        <input
                            id='PersonalDataLastName'
                            autoComplete={'family-name'}
                            tabIndex={isViewOnly ? -1 : 0}
                            className={`form-control${showValidation && !formData.lastName ? ' error' : ''}`}
                            title=''
                            name='lastName'
                            type="text"
                            maxLength={40}
                            value={formData.lastName ?? ''}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group-antrag">
                        <label className='form-label' htmlFor='email' >E-Mail</label>
                        <input
                            id='email'
                            autoComplete={'email'}
                            tabIndex={isViewOnly ? -1 : 0}
                            className={`form-control${showValidation && !formData.email ? ' error' : ''}`}
                            title=''
                            name='email'
                            maxLength={50}
                            type="email"
                            value={formData.email ?? ''}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group-antrag">
                        <label htmlFor='phone' className='form-label'>Telefonnummer</label>
                        <input
                            id='phone'
                            autoComplete={'tel'}
                            tabIndex={isViewOnly ? -1 : 0}
                            className={`form-control${showValidation && !formData.phone ? ' error' : ''}`}
                            title=''
                            name='phone'
                            type="tel"
                            maxLength={20}
                            value={formData.phone ?? ''}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group-antrag">
                        <label htmlFor='birthday' className='form-label'>Geburtsdatum</label>
                        <input
                            id='birthday'
                            autoComplete={'bday'}
                            tabIndex={isViewOnly ? -1 : 0}
                            className={`form-control birthday${showValidation && !formData.birthDate ? ' error' : ''}`}
                            title=''
                            name='birthDate'
                            type="date"
                            value={formatDateForInput(formData.birthDate) ?? ''}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group-antrag">
                        <label className='form-label' htmlFor='birthPlace'>Geburtsort</label>
                        <input
                            id='birthPlace'
                            tabIndex={isViewOnly ? -1 : 0}
                            className={`form-control${showValidation && !formData.birthPlace ? ' error' : ''}`}
                            title=''
                            name='birthPlace'
                            type="text"
                            value={formData.birthPlace ?? ''}
                            maxLength={50}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group-antrag">
                        <label className='form-label' htmlFor='gender'>
                            Geschlecht
                        </label>
                        <select
                            id='gender'
                            tabIndex={isViewOnly ? -1 : 0}
                            className={`form-control form-select${showValidation && !formData.gender ? ' error' : ''}`}
                            title='Wählen Sie Ihr Geschlecht aus'
                            name='gender'
                            value={formData.gender ?? ''}
                            onChange={handleChange}
                        >
                            <option value="" disabled>Bitte auswählen</option>
                            <option value="M">Männlich</option>
                            <option value="W">Weiblich</option>
                            <option value="D">Divers</option>
                        </select>
                    </div>
                    <div className="form-group-antrag">
                        <label className='form-label' htmlFor='familyStatus'>
                            Familienstand
                        </label>
                        <select
                            id='familyStatus'
                            tabIndex={isViewOnly ? -1 : 0}
                            className={`form-control form-select${showValidation && !formData.familyStatus ? ' error' : ''}`}
                            title='Wählen Sie Ihren Familienstand aus'
                            name='familyStatus'
                            value={formData.familyStatus ?? ''}
                            onChange={handleChange}
                        >
                            <option value="" disabled>Bitte auswählen</option>
                            <option value="Ledig">Ledig</option>
                            <option value="Verheiratet">Verheiratet</option>
                            <option value="Geschieden">Geschieden</option>
                            <option value="Verwitwet">Verwitwet</option>
                        </select>
                    </div>
                    {(formData.familyStatus === 'Verheiratet' || formData.familyStatus === 'Geschieden' || formData.familyStatus === 'Verwitwet') && (
                        <div className="form-group-antrag">
                            <label className='form-label' htmlFor='formerName'>
                                Früherere Nachname (Wenn vorhanden)
                            </label>
                            <input
                                id='formerName'
                                tabIndex={isViewOnly ? -1 : 0}
                                className="form-control"
                                title=''
                                name='formerName'
                                type="text"
                                value={formData.formerName ?? ''}
                                maxLength={50}
                                onChange={handleChange}
                            />
                        </div>
                    )}
                    <div className="form-group-antrag">
                        <label className='form-label' htmlFor='citizenship'>
                            Staatsbürgerschaft
                        </label>
                        <select
                            id='citizenship'
                            tabIndex={isViewOnly ? -1 : 0}
                            className={`form-control form-select${showValidation && !formData.citizenship ? ' error' : ''}`}
                            title="Wählen Sie Ihre Staatsbürgerschaft aus"
                            name='citizenship'
                            value={formData.citizenship ?? ''}
                            onChange={handleChange}
                        >
                            <option value="" disabled>Bitte auswählen</option>
                            {countries.map((country, index) => (
                                <option key={index} value={country}>
                                    {country}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
            <h3 style={{ textAlign: "left" }}>Adresse</h3>
            <div className='personal-antrag-data'>
                <div className='form-columns'>
                    <div className="form-group-antrag">
                        <label className='form-label' htmlFor='street'>
                            Straße + Hausnummer
                        </label>
                        <input
                            id='street'
                            tabIndex={isViewOnly ? -1 : 0}
                            className={`form-control${showValidation && !formData.street ? ' error' : ''}`}
                            title=''
                            name='street'
                            type="text"
                            value={formData.street ?? ''}
                            maxLength={50}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group-antrag">
                        <label className='form-label' htmlFor='zip'>
                            Postleitzahl
                        </label>
                        <input
                            id='zip'
                            tabIndex={isViewOnly ? -1 : 0}
                            className={`form-control${showValidation && !formData.zip ? ' error' : ''}`}
                            title=''
                            name='zip'
                            type="text"
                            maxLength={10}
                            value={formData.zip ?? ''}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group-antrag">
                        <label className='form-label' htmlFor='city'>
                            Stadt
                        </label>
                        <input
                            id='city'
                            tabIndex={isViewOnly ? -1 : 0}
                            className={`form-control${showValidation && !formData.city ? ' error' : ''}`}
                            title=''
                            name='city'
                            type="text"
                            value={formData.city ?? ''}
                            maxLength={50}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group-antrag">
                        <label className='form-label' htmlFor='country'>
                            Land
                        </label>
                        <select
                            id='country'
                            autoComplete={'country'}
                            tabIndex={isViewOnly ? -1 : 0}
                            className={`form-control form-select${showValidation && !formData.country ? ' error' : ''}`}
                            title='Wählen Sie Ihr Land aus'
                            name='country'
                            value={formData.country ?? ''}
                            onChange={handleChange}
                        >
                            <option value="" disabled>Bitte auswählen</option>
                            {countries.map((country, index) => (
                                <option key={index} value={country}>
                                    {country}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PersonalDataForm;